/*

Assumption I made:
0 - False
1 - True

Remove BRAF as a mutation annotation
Remove ATM as a mutation annotation
Activate the remaining 5 mutations

*/

/*
Sample Entry
"7316-1052": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "mutated",
    "HARMONY_Diagnosis": "Astrocytoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Female",
    "Diagnosis": "Astrocytoma",
    "HARMONY_WHO_Grade": "4",
    "HARMONY_age": 11.22001971,
    "HARMONY_age_class_derived": "[0,15]",
    "Age class": "PED",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 502,
    "HARMONY_os_status": "mutated",
    "HARMONY_pfs": 232,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Post-treatment",
    "Tumor location": "Cerebellar",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": 1
  }
*/



export default {
  "7316-1052": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "mutated",
    "Diagnosis": "Astrocytoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Female",
    "HARMONY_Simple_Diagnosis": "Astrocytoma",
    "HARMONY_WHO_Grade": "4",
    "HARMONY_age": 11.22001971,
    "HARMONY_age_class_derived": "[0,15]",
    "Age class": "PED",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 502,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 232,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Post-treatment",
    "Tumor location": "Cerebellar",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "mutated",
    "Protein Subtype": "C1"
  },
  "7316-1099": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "mutated",
    "Diagnosis": "Glioblastoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Male",
    "HARMONY_Simple_Diagnosis": "Glioblastoma",
    "HARMONY_WHO_Grade": "4",
    "HARMONY_age": 18.53575731,
    "HARMONY_age_class_derived": "(15,26]",
    "Age class": "ADO",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 2125,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 2125,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Cortical",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "mutated",
    "Protein Subtype": "C1"
  },
  "7316-1106": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "mutated",
    "H3-3A": "wild-type",
    "Diagnosis": "Pleomorphic xanthoastrocytoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Male",
    "HARMONY_Simple_Diagnosis": "Astrocytoma",
    "HARMONY_WHO_Grade": "3",
    "HARMONY_age": 16.64932647,
    "HARMONY_age_class_derived": "(15,26]",
    "Age class": "ADO",
    "HARMONY_dasc": "Alive",
    "Overall Survival Status": "Alive",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Cortical",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "wild-type"
  },
  "7316-114": {
    "ATM": "mutated",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "wild-type",
    "Diagnosis": "HGG/astrocytoma (WHO grade III/IV)",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Female",
    "HARMONY_Simple_Diagnosis": "Glioblastoma",
    "HARMONY_WHO_Grade": "4",
    "HARMONY_age": 30.62096156,
    "HARMONY_age_class_derived": "(26,40]",
    "Age class": "YA",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 697,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 697,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Other/Multiple locations/NOS",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "wild-type",
    "Protein Subtype": "C2"
  },
  "7316-1455": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "wild-type",
    "Diagnosis": "Astrocytoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Female",
    "HARMONY_Simple_Diagnosis": "Astrocytoma",
    "HARMONY_WHO_Grade": "3",
    "HARMONY_age": 1.741320775,
    "HARMONY_age_class_derived": "[0,15]",
    "Age class": "PED",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 2596,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 360,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Cortical",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "mutated",
    "Protein Subtype": "C2"
  },
  "7316-161": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "wild-type",
    "Diagnosis": "Glioblastoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Male",
    "HARMONY_Simple_Diagnosis": "Glioblastoma",
    "HARMONY_WHO_Grade": "4",
    "HARMONY_age": 16.17566532,
    "HARMONY_age_class_derived": "(15,26]",
    "Age class": "ADO",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 2561,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 2369,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Cortical",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "mutated",
    "Protein Subtype": "C2"
  },
  "7316-1723": {
    "ATM": "mutated",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "wild-type",
    "Diagnosis": "HGG/astrocytoma (WHO grade III/IV)",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Female",
    "HARMONY_Simple_Diagnosis": "Glioblastoma",
    "HARMONY_age": 12.00306648,
    "HARMONY_age_class_derived": "[0,15]",
    "Age class": "PED",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 991,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 422,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Cortical",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "wild-type",
    "Protein Subtype": "C1"
  },
  "7316-1746": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "wild-type",
    "Diagnosis": "HGG/astrocytoma (WHO grade III/IV)",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Female",
    "HARMONY_Simple_Diagnosis": "Glioblastoma",
    "HARMONY_WHO_Grade": "4",
    "HARMONY_age": 6.316394699,
    "HARMONY_age_class_derived": "[0,15]",
    "Age class": "PED",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 132,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 23,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Cerebellar",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "mutated",
    "Protein Subtype": "C1"
  },
  "7316-1763": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "mutated",
    "Diagnosis": "Glioblastoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Female",
    "HARMONY_Simple_Diagnosis": "Glioblastoma",
    "HARMONY_WHO_Grade": "4",
    "HARMONY_age": 10.4314971,
    "HARMONY_age_class_derived": "[0,15]",
    "Age class": "PED",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 225,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 17,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Other/Multiple locations/NOS",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "mutated",
    "Protein Subtype": "C1"
  },
  "7316-1769": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "mutated",
    "Diagnosis": "Glioblastoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Male",
    "HARMONY_Simple_Diagnosis": "Glioblastoma",
    "HARMONY_WHO_Grade": "4",
    "HARMONY_age": 17.06822911,
    "HARMONY_age_class_derived": "(15,26]",
    "Age class": "ADO",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 638,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 19,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Post-treatment",
    "Tumor location": "Other/Multiple locations/NOS",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "mutated",
    "TP53": "wild-type",
    "Protein Subtype": "C2"
  },
  "7316-1774": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "wild-type",
    "Diagnosis": "HGG/astrocytoma (WHO grade III/IV)",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Male",
    "HARMONY_Simple_Diagnosis": "Glioblastoma",
    "HARMONY_WHO_Grade": "4",
    "HARMONY_age": 6.929690067,
    "HARMONY_age_class_derived": "[0,15]",
    "Age class": "PED",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 575,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 405,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Post-treatment",
    "Tumor location": "Cortical",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "mutated",
    "TP53": "mutated",
    "Protein Subtype": "C2"
  },
  "7316-1844": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "mutated",
    "Diagnosis": "Glioblastoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Male",
    "HARMONY_Simple_Diagnosis": "Glioblastoma",
    "HARMONY_WHO_Grade": "4",
    "HARMONY_age": 11.58416384,
    "HARMONY_age_class_derived": "[0,15]",
    "Age class": "PED",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 284,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 143,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Other/Multiple locations/NOS",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "mutated",
    "Protein Subtype": "C2"
  },
  "7316-1889": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "mutated",
    "H3-3A": "mutated",
    "Diagnosis": "Glioblastoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Male",
    "HARMONY_Simple_Diagnosis": "Glioblastoma",
    "HARMONY_WHO_Grade": "4",
    "HARMONY_age": 18.3221991,
    "HARMONY_age_class_derived": "(15,26]",
    "Age class": "ADO",
    "HARMONY_dasc": "Deceased-due to disease",
    "HARMONY_os": 605,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 605,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Other/Multiple locations/NOS",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "wild-type",
    "Protein Subtype": "C3"
  },
  "7316-194": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "wild-type",
    "Diagnosis": "Glioblastoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Female",
    "HARMONY_Simple_Diagnosis": "Glioblastoma",
    "HARMONY_WHO_Grade": "4",
    "HARMONY_age": 6.926952141,
    "HARMONY_age_class_derived": "[0,15]",
    "Age class": "PED",
    "HARMONY_dasc": "Deceased-due to disease",
    "HARMONY_os": 10,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 10,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Midline",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "wild-type",
    "Protein Subtype": "C2"
  },
  "7316-1946": {
    "ATM": "wild-type",
    "ATRX": "mutated",
    "BRAF": "wild-type",
    "H3-3A": "wild-type",
    "Diagnosis": "Astrocytoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Male",
    "HARMONY_Simple_Diagnosis": "Astrocytoma",
    "HARMONY_WHO_Grade": "3",
    "HARMONY_age": 25.98291534,
    "HARMONY_age_class_derived": "(15,26]",
    "Age class": "ADO",
    "HARMONY_dasc": "Alive",
    "Overall Survival Status": "Alive",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Cortical",
    "HARMONY_upenn": false,
    "IDH1": "mutated",
    "NF1": "wild-type",
    "TP53": "mutated",
    "Protein Subtype": "C2"
  },
  "7316-195": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "mutated",
    "Diagnosis": "Glioblastoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Male",
    "HARMONY_Simple_Diagnosis": "Glioblastoma",
    "HARMONY_WHO_Grade": "4",
    "HARMONY_age": 9.100865185,
    "HARMONY_age_class_derived": "[0,15]",
    "Age class": "PED",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 276,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 248,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Cerebellar",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "mutated",
    "Protein Subtype": "C2"
  },
  "7316-1956": {
    "ATM": "wild-type",
    "ATRX": "mutated",
    "BRAF": "wild-type",
    "H3-3A": "mutated",
    "Diagnosis": "HGG/astrocytoma (WHO grade III/IV)",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Female",
    "HARMONY_Simple_Diagnosis": "Glioblastoma",
    "HARMONY_WHO_Grade": "4",
    "HARMONY_age": 12.48220348,
    "HARMONY_age_class_derived": "[0,15]",
    "Age class": "PED",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 394,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 394,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Cerebellar",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "mutated",
    "TP53": "wild-type",
    "Protein Subtype": "C2"
  },
  "7316-204": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "wild-type",
    "Diagnosis": "Astrocytoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Female",
    "HARMONY_Simple_Diagnosis": "Astrocytoma",
    "HARMONY_WHO_Grade": "3",
    "HARMONY_age": 13.54178075,
    "HARMONY_age_class_derived": "[0,15]",
    "Age class": "PED",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 360,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 106,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Cortical",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "wild-type",
    "Protein Subtype": "C3"
  },
  "7316-2069": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "wild-type",
    "Diagnosis": "Glioblastoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Male",
    "HARMONY_Simple_Diagnosis": "Glioblastoma",
    "HARMONY_WHO_Grade": "4",
    "HARMONY_age": 6.885883255,
    "HARMONY_age_class_derived": "[0,15]",
    "Age class": "PED",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 957,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 81,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Post-treatment",
    "Tumor location": "Cortical",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "mutated",
    "TP53": "wild-type",
    "Protein Subtype": "C2"
  },
  "7316-2092": {
    "ATM": "wild-type",
    "ATRX": "mutated",
    "BRAF": "wild-type",
    "H3-3A": "wild-type",
    "Diagnosis": "Glioblastoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Female",
    "HARMONY_Simple_Diagnosis": "Glioblastoma",
    "HARMONY_WHO_Grade": "4",
    "HARMONY_age": 2.655787975,
    "HARMONY_age_class_derived": "[0,15]",
    "Age class": "PED",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 516,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 469,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Post-treatment",
    "Tumor location": "Cortical",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "mutated",
    "Protein Subtype": "C2"
  },
  "7316-212": {
    "Diagnosis": "Glioblastoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Female",
    "HARMONY_Simple_Diagnosis": "Glioblastoma",
    "HARMONY_WHO_Grade": "4",
    "HARMONY_age": 18.3331508,
    "HARMONY_age_class_derived": "(15,26]",
    "Age class": "ADO",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 1732,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 1732,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Cortical",
    "HARMONY_upenn": false,
    "Protein Subtype": "C2"
  },
  "7316-2140": {
    "ATM": "wild-type",
    "ATRX": "mutated",
    "BRAF": "wild-type",
    "H3-3A": "wild-type",
    "Diagnosis": "Glioblastoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Male",
    "HARMONY_Simple_Diagnosis": "Glioblastoma",
    "HARMONY_WHO_Grade": "4",
    "HARMONY_age": 20.13470595,
    "HARMONY_age_class_derived": "(15,26]",
    "Age class": "ADO",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 352,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 352,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Cortical",
    "HARMONY_upenn": false,
    "IDH1": "mutated",
    "NF1": "wild-type",
    "TP53": "mutated",
    "Protein Subtype": "C1"
  },
  "7316-2146": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "wild-type",
    "Diagnosis": "Astrocytoma",
    "HARMONY_First_Diagnosis": "No",
    "Sex": "Female",
    "HARMONY_Simple_Diagnosis": "Astrocytoma",
    "HARMONY_WHO_Grade": "3",
    "HARMONY_age": 5.11170737,
    "HARMONY_age_class_derived": "[0,15]",
    "Age class": "PED",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 1250,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 279,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Post-treatment",
    "Tumor location": "Other/Multiple locations/NOS",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "wild-type",
    "Protein Subtype": "C1"
  },
  "7316-2151": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "wild-type",
    "Diagnosis": "Astrocytoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Male",
    "HARMONY_Simple_Diagnosis": "Astrocytoma",
    "HARMONY_WHO_Grade": "3",
    "HARMONY_age": 6.020698719,
    "HARMONY_age_class_derived": "[0,15]",
    "Age class": "PED",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 482,
    "Overall Survival Status": "Alive",
    "HARMONY_pfs": 482,
    "HARMONY_pfs_status": "wild-type",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Midline",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "wild-type",
    "Protein Subtype": "C2"
  },
  "7316-2152": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "mutated",
    "Diagnosis": "HGG/astrocytoma (WHO grade III/IV)",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Male",
    "HARMONY_Simple_Diagnosis": "Astrocytoma",
    "HARMONY_WHO_Grade": "3",
    "HARMONY_age": 12.05234914,
    "HARMONY_age_class_derived": "[0,15]",
    "Age class": "PED",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 482,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 91,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Midline",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "mutated",
    "Protein Subtype": "C2"
  },
  "7316-2176": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "wild-type",
    "Diagnosis": "HGG/astrocytoma (WHO grade III/IV)",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Female",
    "HARMONY_Simple_Diagnosis": "Astrocytoma",
    "HARMONY_WHO_Grade": "3",
    "HARMONY_age": 16.89300186,
    "HARMONY_age_class_derived": "(15,26]",
    "Age class": "ADO",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 1776,
    "Overall Survival Status": "Alive",
    "HARMONY_pfs": 1776,
    "HARMONY_pfs_status": "wild-type",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Other/Multiple locations/NOS",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "wild-type",
    "Protein Subtype": "C2"
  },
  "7316-2241": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "wild-type",
    "Diagnosis": "Glioblastoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Female",
    "HARMONY_Simple_Diagnosis": "Glioblastoma",
    "HARMONY_WHO_Grade": "4",
    "HARMONY_age": 6.497097799,
    "HARMONY_age_class_derived": "[0,15]",
    "Age class": "PED",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 749,
    "Overall Survival Status": "Alive",
    "HARMONY_pfs": 749,
    "HARMONY_pfs_status": "wild-type",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Cortical",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "wild-type",
    "Protein Subtype": "C1"
  },
  "7316-2274": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "wild-type",
    "Diagnosis": "Glioblastoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Female",
    "HARMONY_Simple_Diagnosis": "Glioblastoma",
    "HARMONY_WHO_Grade": "4",
    "HARMONY_age": 0.227247837,
    "HARMONY_age_class_derived": "[0,15]",
    "Age class": "PED",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 1596,
    "Overall Survival Status": "Alive",
    "HARMONY_pfs": 482,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Cortical",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "wild-type",
    "Protein Subtype": "C1"
  },
  "7316-231": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "mutated",
    "Diagnosis": "Astrocytoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Female",
    "HARMONY_Simple_Diagnosis": "Astrocytoma",
    "HARMONY_WHO_Grade": "3",
    "HARMONY_age": 21.39962764,
    "HARMONY_age_class_derived": "(15,26]",
    "Age class": "ADO",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 1536,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 155,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Midline",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "wild-type",
    "Protein Subtype": "C2"
  },
  "7316-24": {
    "Diagnosis": "Glioblastoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Female",
    "HARMONY_Simple_Diagnosis": "Glioblastoma",
    "HARMONY_WHO_Grade": "4",
    "HARMONY_age": 15.58974921,
    "HARMONY_age_class_derived": "(15,26]",
    "Age class": "ADO",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 605,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 524,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Cerebellar",
    "HARMONY_upenn": false,
    "Protein Subtype": "C2"
  },
  "7316-2536": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "mutated",
    "Diagnosis": "Glioblastoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Female",
    "HARMONY_Simple_Diagnosis": "Glioblastoma",
    "HARMONY_WHO_Grade": "4",
    "HARMONY_age": 12.74778228,
    "HARMONY_age_class_derived": "[0,15]",
    "Age class": "PED",
    "HARMONY_dasc": "Deceased-due to disease",
    "HARMONY_os": 243,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 243,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Midline",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "mutated",
    "Protein Subtype": "C2"
  },
  "7316-255": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "mutated",
    "H3-3A": "wild-type",
    "Diagnosis": "Glioblastoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Female",
    "HARMONY_Simple_Diagnosis": "Glioblastoma",
    "HARMONY_WHO_Grade": "4",
    "HARMONY_age": 16.75610557,
    "HARMONY_age_class_derived": "(15,26]",
    "Age class": "ADO",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 151,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 60,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Cortical",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "wild-type",
    "Protein Subtype": "C2"
  },
  "7316-2594": {
    "ATM": "mutated",
    "ATRX": "mutated",
    "BRAF": "wild-type",
    "H3-3A": "mutated",
    "Diagnosis": "Astrocytoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Male",
    "HARMONY_Simple_Diagnosis": "Astrocytoma",
    "HARMONY_WHO_Grade": "3",
    "HARMONY_age": 7.855108969,
    "HARMONY_age_class_derived": "[0,15]",
    "Age class": "PED",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 273,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 92,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Midline",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "mutated",
    "TP53": "wild-type",
    "Protein Subtype": "C2"
  },
  "7316-2599": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "wild-type",
    "Diagnosis": "Astrocytoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Male",
    "HARMONY_Simple_Diagnosis": "Astrocytoma",
    "HARMONY_WHO_Grade": "3",
    "HARMONY_age": 2.757091228,
    "HARMONY_age_class_derived": "[0,15]",
    "Age class": "PED",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 942,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 611,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Cortical",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "wild-type",
    "Protein Subtype": "C2"
  },
  "7316-2660": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "wild-type",
    "Diagnosis": "Astrocytoma",
    "HARMONY_First_Diagnosis": "No",
    "Sex": "Female",
    "HARMONY_Simple_Diagnosis": "Astrocytoma",
    "HARMONY_WHO_Grade": "3",
    "HARMONY_age": 5.875588654,
    "HARMONY_age_class_derived": "[0,15]",
    "Age class": "PED",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 1250,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 84,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Post-treatment",
    "Tumor location": "Other/Multiple locations/NOS",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "wild-type",
    "Protein Subtype": "C2"
  },
  "7316-2737": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "wild-type",
    "Diagnosis": "Glioblastoma",
    "HARMONY_First_Diagnosis": "No",
    "Sex": "Male",
    "HARMONY_Simple_Diagnosis": "Glioblastoma",
    "HARMONY_WHO_Grade": "4",
    "HARMONY_age": 7.781184974,
    "HARMONY_age_class_derived": "[0,15]",
    "Age class": "PED",
    "HARMONY_dasc": "Deceased-due to disease",
    "HARMONY_os": 957,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 957,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Post-treatment",
    "Tumor location": "Cortical",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "mutated",
    "TP53": "wild-type",
    "Protein Subtype": "C2"
  },
  "7316-2777": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "wild-type",
    "Diagnosis": "Glioblastoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Male",
    "HARMONY_Simple_Diagnosis": "Glioblastoma",
    "HARMONY_WHO_Grade": "4",
    "HARMONY_age": 5.051473004,
    "HARMONY_age_class_derived": "[0,15]",
    "Age class": "PED",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 403,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 398,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Cortical",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "wild-type",
    "Protein Subtype": "C2"
  },
  "7316-2810": {
    "ATM": "wild-type",
    "ATRX": "mutated",
    "BRAF": "wild-type",
    "H3-3A": "mutated",
    "Diagnosis": "Astrocytoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Male",
    "HARMONY_Simple_Diagnosis": "Astrocytoma",
    "HARMONY_WHO_Grade": "3",
    "HARMONY_age": 10.13580112,
    "HARMONY_age_class_derived": "[0,15]",
    "Age class": "PED",
    "HARMONY_dasc": "Deceased-due to disease",
    "HARMONY_os": 419,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 419,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Post-treatment",
    "Tumor location": "Midline",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "mutated",
    "Protein Subtype": "C2"
  },
  "7316-2857": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "wild-type",
    "Diagnosis": "Glioblastoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Male",
    "HARMONY_Simple_Diagnosis": "Glioblastoma",
    "HARMONY_WHO_Grade": "4",
    "HARMONY_age": 1.349797393,
    "HARMONY_age_class_derived": "[0,15]",
    "Age class": "PED",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 648,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 648,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Cortical",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "wild-type",
    "Protein Subtype": "C1"
  },
  "7316-287": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "wild-type",
    "Diagnosis": "Glioblastoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Male",
    "HARMONY_Simple_Diagnosis": "Glioblastoma",
    "HARMONY_WHO_Grade": "4",
    "HARMONY_age": 14.46719965,
    "HARMONY_age_class_derived": "[0,15]",
    "Age class": "PED",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 422,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 325,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Cortical",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "mutated",
    "Protein Subtype": "C2"
  },
  "7316-288": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "mutated",
    "Diagnosis": "Glioblastoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Female",
    "HARMONY_Simple_Diagnosis": "Glioblastoma",
    "HARMONY_WHO_Grade": "4",
    "HARMONY_age": 14.68075786,
    "HARMONY_age_class_derived": "[0,15]",
    "Age class": "PED",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 791,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 691,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Midline",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "wild-type",
    "Protein Subtype": "C1"
  },
  "7316-3000": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "wild-type",
    "Diagnosis": "Glioblastoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Female",
    "HARMONY_Simple_Diagnosis": "Glioblastoma",
    "HARMONY_WHO_Grade": "4",
    "HARMONY_age": 9.39382324,
    "HARMONY_age_class_derived": "[0,15]",
    "Age class": "PED",
    "HARMONY_dasc": "Deceased-due to disease",
    "HARMONY_os": 1189,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 1189,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Post-treatment",
    "Tumor location": "Cortical",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "wild-type"
  },
  "7316-3058": {
    "ATM": "mutated",
    "ATRX": "mutated",
    "BRAF": "wild-type",
    "H3-3A": "mutated",
    "Diagnosis": "Diffuse Midline Glioma",
    "HARMONY_First_Diagnosis": "No",
    "Sex": "Male",
    "HARMONY_Simple_Diagnosis": "Glioblastoma",
    "HARMONY_WHO_Grade": "4",
    "HARMONY_age": 8.487569817,
    "HARMONY_age_class_derived": "[0,15]",
    "Age class": "PED",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 273,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 40,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Post-treatment",
    "Tumor location": "Midline",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "mutated",
    "TP53": "mutated",
    "Protein Subtype": "C2"
  },
  "7316-3075": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "wild-type",
    "Diagnosis": "Glioblastoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Male",
    "HARMONY_Simple_Diagnosis": "Glioblastoma",
    "HARMONY_WHO_Grade": "4",
    "HARMONY_age": 0.703646917,
    "HARMONY_age_class_derived": "[0,15]",
    "Age class": "PED",
    "HARMONY_dasc": "Alive",
    "Overall Survival Status": "Alive",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Cortical",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "wild-type",
    "Protein Subtype": "C1"
  },
  "7316-3303": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "wild-type",
    "Diagnosis": "Glioblastoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Male",
    "HARMONY_Simple_Diagnosis": "Glioblastoma",
    "HARMONY_WHO_Grade": "4",
    "HARMONY_age": 26.59621071,
    "HARMONY_age_class_derived": "(26,40]",
    "Age class": "YA",
    "HARMONY_dasc": "Deceased-due to disease",
    "HARMONY_os": 940,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 940,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Post-treatment",
    "Tumor location": "Midline",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "mutated",
    "TP53": "mutated",
    "Protein Subtype": "C2"
  },
  "7316-3521": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "mutated",
    "H3-3A": "mutated",
    "Diagnosis": "HGG/astrocytoma (WHO grade III/IV)",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Female",
    "HARMONY_Simple_Diagnosis": "Glioblastoma",
    "HARMONY_age": 14.25090352,
    "HARMONY_age_class_derived": "[0,15]",
    "Age class": "PED",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 1017,
    "Overall Survival Status": "Alive",
    "HARMONY_pfs": 1017,
    "HARMONY_pfs_status": "wild-type",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Midline",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "wild-type",
    "Protein Subtype": "C2"
  },
  "7316-3636": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "wild-type",
    "Diagnosis": "Glioblastoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Male",
    "HARMONY_Simple_Diagnosis": "Glioblastoma",
    "HARMONY_WHO_Grade": "4",
    "HARMONY_age": 7.39787537,
    "HARMONY_age_class_derived": "[0,15]",
    "Age class": "PED",
    "HARMONY_dasc": "Alive",
    "Overall Survival Status": "Alive",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Cortical",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "mutated",
    "Protein Subtype": "C1"
  },
  "7316-37": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "wild-type",
    "Diagnosis": "Astrocytoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Female",
    "HARMONY_Simple_Diagnosis": "Astrocytoma",
    "HARMONY_WHO_Grade": "3",
    "HARMONY_age": 30.52787208,
    "HARMONY_age_class_derived": "(26,40]",
    "Age class": "YA",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 1999,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 113,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Post-treatment",
    "Tumor location": "Other/Multiple locations/NOS",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "mutated",
    "TP53": "wild-type",
    "Protein Subtype": "C3"
  },
  "7316-371": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "wild-type",
    "Diagnosis": "HGG/astrocytoma (WHO grade III/IV)",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Female",
    "HARMONY_Simple_Diagnosis": "Glioblastoma",
    "HARMONY_WHO_Grade": "4",
    "HARMONY_age": 9.94688424,
    "HARMONY_age_class_derived": "[0,15]",
    "Age class": "PED",
    "HARMONY_dasc": "Deceased-due to disease",
    "HARMONY_os": 1747,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 1747,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Post-treatment",
    "Tumor location": "Other/Multiple locations/NOS",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "mutated",
    "Protein Subtype": "C1"
  },
  "7316-3765": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "wild-type",
    "Diagnosis": "Glioblastoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Female",
    "HARMONY_Simple_Diagnosis": "Glioblastoma",
    "HARMONY_WHO_Grade": "4",
    "HARMONY_age": 6.696966378,
    "HARMONY_age_class_derived": "[0,15]",
    "Age class": "PED",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 349,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 104,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Cortical",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "wild-type",
    "Protein Subtype": "C3"
  },
  "7316-3769": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "wild-type",
    "Diagnosis": "Glioblastoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Female",
    "HARMONY_Simple_Diagnosis": "Glioblastoma",
    "HARMONY_WHO_Grade": "4",
    "HARMONY_age": 8.501259446,
    "HARMONY_age_class_derived": "[0,15]",
    "Age class": "PED",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 1660,
    "Overall Survival Status": "Alive",
    "HARMONY_pfs": 947,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Other/Multiple locations/NOS",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "wild-type",
    "Protein Subtype": "C1"
  },
  "7316-3771": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "mutated",
    "Diagnosis": "Diffuse Midline Glioma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Male",
    "HARMONY_Simple_Diagnosis": "Glioblastoma",
    "HARMONY_WHO_Grade": "3",
    "HARMONY_age": 11.74570146,
    "HARMONY_age_class_derived": "[0,15]",
    "Age class": "PED",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 814,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 396,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Other/Multiple locations/NOS",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "wild-type",
    "Protein Subtype": "C1"
  },
  "7316-388": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "mutated",
    "Diagnosis": "Astrocytoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Female",
    "HARMONY_Simple_Diagnosis": "Astrocytoma",
    "HARMONY_WHO_Grade": "3",
    "HARMONY_age": 5.193845143,
    "HARMONY_age_class_derived": "[0,15]",
    "Age class": "PED",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 294,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 215,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Midline",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "mutated",
    "Protein Subtype": "C1"
  },
  "7316-3935": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "mutated",
    "Diagnosis": "Diffuse Midline Glioma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Male",
    "HARMONY_Simple_Diagnosis": "Glioblastoma",
    "HARMONY_WHO_Grade": "4",
    "HARMONY_age": 12.29054868,
    "HARMONY_age_class_derived": "[0,15]",
    "Age class": "PED",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 18,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 18,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Other/Multiple locations/NOS",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "mutated",
    "Protein Subtype": "C2"
  },
  "7316-409": {
    "ATM": "wild-type",
    "ATRX": "mutated",
    "BRAF": "wild-type",
    "H3-3A": "mutated",
    "Diagnosis": "Glioblastoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Female",
    "HARMONY_Simple_Diagnosis": "Glioblastoma",
    "HARMONY_WHO_Grade": "4",
    "HARMONY_age": 11.6443982,
    "HARMONY_age_class_derived": "[0,15]",
    "Age class": "PED",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 611,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 111,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Midline",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "mutated",
    "TP53": "mutated",
    "Protein Subtype": "C3"
  },
  "7316-4215": {
    "ATM": "wild-type",
    "ATRX": "mutated",
    "BRAF": "mutated",
    "H3-3A": "wild-type",
    "Diagnosis": "Astrocytoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Male",
    "HARMONY_Simple_Diagnosis": "Astrocytoma",
    "HARMONY_WHO_Grade": "3",
    "HARMONY_age": 12.44387252,
    "HARMONY_age_class_derived": "[0,15]",
    "Age class": "PED",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 315,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 190,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Other/Multiple locations/NOS",
    "HARMONY_upenn": false,
    "IDH1": "mutated",
    "NF1": "mutated",
    "TP53": "mutated",
    "Protein Subtype": "C3"
  },
  "7316-4293": {
    "ATM": "wild-type",
    "ATRX": "mutated",
    "BRAF": "wild-type",
    "H3-3A": "wild-type",
    "Diagnosis": "Glioblastoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Male",
    "HARMONY_Simple_Diagnosis": "Glioblastoma",
    "HARMONY_WHO_Grade": "4",
    "HARMONY_age": 18.8752601,
    "HARMONY_age_class_derived": "(15,26]",
    "Age class": "ADO",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 2218,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 381,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Post-treatment",
    "Tumor location": "Cortical",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "mutated",
    "Protein Subtype": "C1"
  },
  "7316-4337": {
    "ATM": "mutated",
    "ATRX": "wild-type",
    "BRAF": "mutated",
    "H3-3A": "wild-type",
    "Diagnosis": "Pleomorphic xanthoastrocytoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Female",
    "HARMONY_Simple_Diagnosis": "Astrocytoma",
    "HARMONY_WHO_Grade": "3",
    "HARMONY_age": 17.06549118,
    "HARMONY_age_class_derived": "(15,26]",
    "Age class": "ADO",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 496,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 294,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Cortical",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "wild-type",
    "Protein Subtype": "C1"
  },
  "7316-4432": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "mutated",
    "H3-3A": "wild-type",
    "Diagnosis": "Glioblastoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Female",
    "HARMONY_Simple_Diagnosis": "Glioblastoma",
    "HARMONY_WHO_Grade": "4",
    "HARMONY_age": 17.61033841,
    "HARMONY_age_class_derived": "(15,26]",
    "Age class": "ADO",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 819,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 291,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Cortical",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "wild-type",
    "Protein Subtype": "C1"
  },
  "7316-445": {
    "ATM": "mutated",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "wild-type",
    "Diagnosis": "Astrocytoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Male",
    "HARMONY_Simple_Diagnosis": "Astrocytoma",
    "HARMONY_WHO_Grade": "3",
    "HARMONY_age": 18.56039864,
    "HARMONY_age_class_derived": "(15,26]",
    "Age class": "ADO",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 697,
    "Overall Survival Status": "Alive",
    "HARMONY_pfs": 697,
    "HARMONY_pfs_status": "wild-type",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Cortical",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "wild-type",
    "Protein Subtype": "C3"
  },
  "7316-4466": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "mutated",
    "H3-3A": "wild-type",
    "Diagnosis": "Pleomorphic xanthoastrocytoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Male",
    "HARMONY_Simple_Diagnosis": "Astrocytoma",
    "HARMONY_WHO_Grade": "3",
    "HARMONY_age": 10.50815902,
    "HARMONY_age_class_derived": "[0,15]",
    "Age class": "PED",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 379,
    "Overall Survival Status": "Alive",
    "HARMONY_pfs": 379,
    "HARMONY_pfs_status": "wild-type",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Cortical",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "wild-type",
    "Protein Subtype": "C2"
  },
  "7316-4516": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "mutated",
    "Diagnosis": "HGG/astrocytoma (WHO grade III/IV)",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Female",
    "HARMONY_Simple_Diagnosis": "Glioblastoma",
    "HARMONY_WHO_Grade": "4",
    "HARMONY_age": 14.60135801,
    "HARMONY_age_class_derived": "[0,15]",
    "Age class": "PED",
    "HARMONY_dasc": "Alive",
    "Overall Survival Status": "Alive",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Midline",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "mutated",
    "TP53": "mutated",
    "Protein Subtype": "C2"
  },
  "7316-4552": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "wild-type",
    "Diagnosis": "Astrocytoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Male",
    "HARMONY_Simple_Diagnosis": "Astrocytoma",
    "HARMONY_age": 0.922680977,
    "HARMONY_age_class_derived": "[0,15]",
    "Age class": "PED",
    "HARMONY_dasc": "Alive",
    "Overall Survival Status": "Alive",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Cortical",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "wild-type",
    "Protein Subtype": "C2"
  },
  "7316-466": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "mutated",
    "Diagnosis": "Astrocytoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Male",
    "HARMONY_Simple_Diagnosis": "Astrocytoma",
    "HARMONY_WHO_Grade": "3",
    "HARMONY_age": 7.135034498,
    "HARMONY_age_class_derived": "[0,15]",
    "Age class": "PED",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 1569,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 889,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Midline",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "mutated",
    "TP53": "wild-type",
    "Protein Subtype": "C1"
  },
  "7316-4723": {
    "ATM": "wild-type",
    "ATRX": "mutated",
    "BRAF": "wild-type",
    "H3-3A": "mutated",
    "Diagnosis": "Astrocytoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Female",
    "HARMONY_Simple_Diagnosis": "Astrocytoma",
    "HARMONY_WHO_Grade": "4",
    "HARMONY_age": 16.00043807,
    "HARMONY_age_class_derived": "(15,26]",
    "Age class": "ADO",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 641,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 586,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Cortical",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "mutated",
    "Protein Subtype": "C1"
  },
  "7316-4842": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "wild-type",
    "Diagnosis": "Glioblastoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Male",
    "HARMONY_Simple_Diagnosis": "Glioblastoma",
    "HARMONY_WHO_Grade": "4",
    "HARMONY_age": 0.722812397,
    "HARMONY_age_class_derived": "[0,15]",
    "Age class": "PED",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 791,
    "Overall Survival Status": "Alive",
    "HARMONY_pfs": 791,
    "HARMONY_pfs_status": "wild-type",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Cortical",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "wild-type",
    "Protein Subtype": "C2"
  },
  "7316-4844": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "wild-type",
    "Diagnosis": "Astrocytoma",
    "HARMONY_First_Diagnosis": "No",
    "Sex": "Male",
    "HARMONY_Simple_Diagnosis": "Astrocytoma",
    "HARMONY_WHO_Grade": "1-2?",
    "HARMONY_age": 0.739239952,
    "HARMONY_age_class_derived": "[0,15]",
    "Age class": "PED",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 791,
    "Overall Survival Status": "Alive",
    "HARMONY_pfs": 791,
    "HARMONY_pfs_status": "wild-type",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Cortical",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "wild-type",
    "Protein Subtype": "C2"
  },
  "7316-4917": {
    "ATM": "wild-type",
    "ATRX": "mutated",
    "BRAF": "wild-type",
    "H3-3A": "wild-type",
    "Diagnosis": "Glioblastoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Male",
    "HARMONY_Simple_Diagnosis": "Glioblastoma",
    "HARMONY_WHO_Grade": "4",
    "HARMONY_age": 16.68218158,
    "HARMONY_age_class_derived": "(15,26]",
    "Age class": "ADO",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 974,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 470,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Cortical",
    "HARMONY_upenn": false,
    "IDH1": "mutated",
    "NF1": "mutated",
    "TP53": "mutated",
    "Protein Subtype": "C2"
  },
  "7316-4942": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "wild-type",
    "Diagnosis": "Glioblastoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Male",
    "HARMONY_Simple_Diagnosis": "Glioblastoma",
    "HARMONY_WHO_Grade": "4",
    "HARMONY_age": 9.662139963,
    "HARMONY_age_class_derived": "[0,15]",
    "Age class": "PED",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 341,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 297,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Post-treatment",
    "Tumor location": "Midline",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "mutated",
    "Protein Subtype": "C2"
  },
  "7316-4993": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "wild-type",
    "Diagnosis": "Glioblastoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Male",
    "HARMONY_Simple_Diagnosis": "Glioblastoma",
    "HARMONY_WHO_Grade": "4",
    "HARMONY_age": 10.10294601,
    "HARMONY_age_class_derived": "[0,15]",
    "Age class": "PED",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 382,
    "Overall Survival Status": "Alive",
    "HARMONY_pfs": 112,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Other/Multiple locations/NOS",
    "HARMONY_upenn": false,
    "IDH1": "mutated",
    "NF1": "mutated",
    "TP53": "mutated",
    "Protein Subtype": "C2"
  },
  "7316-5087": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "wild-type",
    "Diagnosis": "Glioblastoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Male",
    "HARMONY_Simple_Diagnosis": "Glioblastoma",
    "HARMONY_WHO_Grade": "4",
    "HARMONY_age": 10.48077976,
    "HARMONY_age_class_derived": "[0,15]",
    "Age class": "PED",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 1303,
    "Overall Survival Status": "Alive",
    "HARMONY_pfs": 236,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Other/Multiple locations/NOS",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "wild-type",
    "Protein Subtype": "C2"
  },
  "7316-5267": {
    "ATM": "wild-type",
    "ATRX": "mutated",
    "BRAF": "wild-type",
    "H3-3A": "mutated",
    "Diagnosis": "HGG/astrocytoma (WHO grade III/IV)",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Male",
    "HARMONY_Simple_Diagnosis": "Astrocytoma",
    "HARMONY_WHO_Grade": "3",
    "HARMONY_age": 18.0347169,
    "HARMONY_age_class_derived": "(15,26]",
    "Age class": "ADO",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 30,
    "Overall Survival Status": "Alive",
    "HARMONY_pfs": 30,
    "HARMONY_pfs_status": "wild-type",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Cortical",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "mutated",
    "Protein Subtype": "C1"
  },
  "7316-5928": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "mutated",
    "Diagnosis": "Diffuse Midline Glioma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Female",
    "HARMONY_Simple_Diagnosis": "Glioblastoma",
    "HARMONY_WHO_Grade": "4",
    "HARMONY_age": 5.752381995,
    "HARMONY_age_class_derived": "[0,15]",
    "Age class": "PED",
    "HARMONY_dasc": "Deceased-due to disease",
    "HARMONY_os": 367,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 367,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Post-treatment",
    "Tumor location": "Midline",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "mutated",
    "Protein Subtype": "C1"
  },
  "7316-619": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "wild-type",
    "Diagnosis": "Glioblastoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Female",
    "HARMONY_Simple_Diagnosis": "Glioblastoma",
    "HARMONY_WHO_Grade": "4",
    "HARMONY_age": 3.537400066,
    "HARMONY_age_class_derived": "[0,15]",
    "Age class": "PED",
    "HARMONY_dasc": "Alive",
    "Overall Survival Status": "Alive",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Cortical",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "wild-type",
    "Protein Subtype": "C2"
  },
  "7316-620": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "wild-type",
    "Diagnosis": "Glioblastoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Female",
    "HARMONY_Simple_Diagnosis": "Glioblastoma",
    "HARMONY_WHO_Grade": "4",
    "HARMONY_age": 0.525681744,
    "HARMONY_age_class_derived": "[0,15]",
    "Age class": "PED",
    "HARMONY_dasc": "Alive",
    "Overall Survival Status": "Alive",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Cortical",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "wild-type",
    "Protein Subtype": "C1"
  },
  "7316-622": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "wild-type",
    "Diagnosis": "Glioblastoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Male",
    "HARMONY_Simple_Diagnosis": "Glioblastoma",
    "HARMONY_WHO_Grade": "4",
    "HARMONY_age": 8.802431278,
    "HARMONY_age_class_derived": "[0,15]",
    "Age class": "PED",
    "HARMONY_dasc": "Alive",
    "Overall Survival Status": "Alive",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Cortical",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "mutated",
    "Protein Subtype": "C1"
  },
  "7316-624": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "wild-type",
    "Diagnosis": "Glioblastoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Female",
    "HARMONY_Simple_Diagnosis": "Glioblastoma",
    "HARMONY_WHO_Grade": "4",
    "HARMONY_age": 10.2398423,
    "HARMONY_age_class_derived": "[0,15]",
    "Age class": "PED",
    "HARMONY_dasc": "Alive",
    "Overall Survival Status": "Alive",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Cortical",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "wild-type",
    "Protein Subtype": "C3"
  },
  "7316-6310": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "wild-type",
    "Diagnosis": "Astrocytoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Male",
    "HARMONY_Simple_Diagnosis": "Astrocytoma",
    "HARMONY_WHO_Grade": "3",
    "HARMONY_age": 22.59883912,
    "HARMONY_age_class_derived": "(15,26]",
    "Age class": "ADO",
    "HARMONY_dasc": "Deceased-due to disease",
    "HARMONY_os": 402,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 402,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Post-treatment",
    "Tumor location": "Midline",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "wild-type",
    "Protein Subtype": "C2"
  },
  "7316-85": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "mutated",
    "H3-3A": "wild-type",
    "Diagnosis": "Glioblastoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Male",
    "HARMONY_Simple_Diagnosis": "Glioblastoma",
    "HARMONY_WHO_Grade": "4",
    "HARMONY_age": 2.516153762,
    "HARMONY_age_class_derived": "[0,15]",
    "Age class": "PED",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 515,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 515,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Cortical",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "wild-type",
    "Protein Subtype": "C2"
  },
  "7316-870": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "mutated",
    "H3-3A": "wild-type",
    "Diagnosis": "HGG/astrocytoma (WHO grade III/IV)",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Female",
    "HARMONY_Simple_Diagnosis": "Astrocytoma",
    "HARMONY_WHO_Grade": "3",
    "HARMONY_age": 10.23710437,
    "HARMONY_age_class_derived": "[0,15]",
    "Age class": "PED",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 855,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 140,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Cortical",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "wild-type",
    "Protein Subtype": "C2"
  },
  "7316-89": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "wild-type",
    "Diagnosis": "HGG/astrocytoma (WHO grade III/IV)",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Male",
    "HARMONY_Simple_Diagnosis": "Astrocytoma",
    "HARMONY_WHO_Grade": "3",
    "HARMONY_age": 17.47070419,
    "HARMONY_age_class_derived": "(15,26]",
    "Age class": "ADO",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 2238,
    "Overall Survival Status": "Alive",
    "HARMONY_pfs": 1697,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Cortical",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "wild-type",
    "Protein Subtype": "C3"
  },
  "7316-895": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "wild-type",
    "Diagnosis": "HGG/astrocytoma (WHO grade III/IV)",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Female",
    "HARMONY_Simple_Diagnosis": "Astrocytoma",
    "HARMONY_WHO_Grade": "3",
    "HARMONY_age": 4.180812616,
    "HARMONY_age_class_derived": "[0,15]",
    "Age class": "PED",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 1250,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 340,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Post-treatment",
    "Tumor location": "Other/Multiple locations/NOS",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "wild-type",
    "Protein Subtype": "C2"
  },
  "7316-913": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "wild-type",
    "Diagnosis": "Glioblastoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Female",
    "HARMONY_Simple_Diagnosis": "Glioblastoma",
    "HARMONY_WHO_Grade": "4",
    "HARMONY_age": 21.58580659,
    "HARMONY_age_class_derived": "(15,26]",
    "Age class": "ADO",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 398,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 216,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Cortical",
    "HARMONY_upenn": false,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "wild-type",
    "Protein Subtype": "C2"
  },
  "7316-942": {
    "Diagnosis": "HGG/astrocytoma (WHO grade III/IV)",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Female",
    "HARMONY_Simple_Diagnosis": "Glioblastoma",
    "HARMONY_WHO_Grade": "4",
    "HARMONY_age": 13.16394699,
    "HARMONY_age_class_derived": "[0,15]",
    "Age class": "PED",
    "HARMONY_dasc": "Deceased-due to disease",
    "HARMONY_os": 615,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 615,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Post-treatment",
    "Tumor location": "Cortical",
    "HARMONY_upenn": false,
    "Protein Subtype": "C2"
  },
  "7316UP-1104": {
    "ATM": "mutated",
    "ATRX": "mutated",
    "BRAF": "wild-type",
    "H3-3A": "mutated",
    "Diagnosis": "Astrocytoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Female",
    "HARMONY_Simple_Diagnosis": "Astrocytoma",
    "HARMONY_WHO_Grade": "3",
    "HARMONY_age": 18.62884679,
    "HARMONY_age_class_derived": "(15,26]",
    "Age class": "ADO",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 1368,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 654,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Other/Multiple locations/NOS",
    "HARMONY_upenn": true,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "mutated",
    "Protein Subtype": "C1"
  },
  "7316UP-1962": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "wild-type",
    "Diagnosis": "Glioblastoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Male",
    "HARMONY_Simple_Diagnosis": "Glioblastoma",
    "HARMONY_WHO_Grade": "4",
    "HARMONY_age": 39.23173804,
    "HARMONY_age_class_derived": "(26,40]",
    "Age class": "YA",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 639,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 252,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Other/Multiple locations/NOS",
    "HARMONY_upenn": true,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "wild-type",
    "Protein Subtype": "C3"
  },
  "7316UP-2035": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "wild-type",
    "Diagnosis": "Glioblastoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Female",
    "HARMONY_Simple_Diagnosis": "Glioblastoma",
    "HARMONY_WHO_Grade": "4",
    "HARMONY_age": 25.59412989,
    "HARMONY_age_class_derived": "(15,26]",
    "Age class": "ADO",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 458,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 204,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Other/Multiple locations/NOS",
    "HARMONY_upenn": true,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "mutated",
    "Protein Subtype": "C3"
  },
  "7316UP-2058": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "wild-type",
    "Diagnosis": "Glioblastoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Male",
    "HARMONY_Simple_Diagnosis": "Glioblastoma",
    "HARMONY_WHO_Grade": "4",
    "HARMONY_age": 38.90592487,
    "HARMONY_age_class_derived": "(26,40]",
    "Age class": "YA",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 693,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 175,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Other/Multiple locations/NOS",
    "HARMONY_upenn": true,
    "IDH1": "wild-type",
    "NF1": "mutated",
    "TP53": "wild-type",
    "Protein Subtype": "C2"
  },
  "7316UP-2333": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "wild-type",
    "Diagnosis": "Glioblastoma",
    "HARMONY_First_Diagnosis": "No",
    "Sex": "Male",
    "HARMONY_Simple_Diagnosis": "Glioblastoma",
    "HARMONY_WHO_Grade": "4",
    "HARMONY_age": 39.38506188,
    "HARMONY_age_class_derived": "(26,40]",
    "Age class": "YA",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 693,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 133,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Post-treatment",
    "Tumor location": "Other/Multiple locations/NOS",
    "HARMONY_upenn": true,
    "IDH1": "wild-type",
    "NF1": "mutated",
    "TP53": "wild-type",
    "Protein Subtype": "C3"
  },
  "7316UP-2403": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "wild-type",
    "Diagnosis": "Glioblastoma",
    "HARMONY_First_Diagnosis": "No",
    "Sex": "Male",
    "HARMONY_Simple_Diagnosis": "Glioblastoma",
    "HARMONY_WHO_Grade": "4",
    "HARMONY_age": 39.92169532,
    "HARMONY_age_class_derived": "(26,40]",
    "Age class": "YA",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 639,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 639,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Post-treatment",
    "Tumor location": "Other/Multiple locations/NOS",
    "HARMONY_upenn": true,
    "IDH1": "mutated",
    "NF1": "wild-type",
    "TP53": "mutated",
    "Protein Subtype": "C3"
  },
  "7316UP-310": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "wild-type",
    "Diagnosis": "Glioblastoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Female",
    "HARMONY_Simple_Diagnosis": "Glioblastoma",
    "HARMONY_WHO_Grade": "4",
    "HARMONY_age": 23.97327784,
    "HARMONY_age_class_derived": "(15,26]",
    "Age class": "ADO",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 1525,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 1364,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Treatment naive",
    "Tumor location": "Other/Multiple locations/NOS",
    "HARMONY_upenn": true,
    "IDH1": "wild-type",
    "NF1": "wild-type",
    "TP53": "wild-type",
    "Protein Subtype": "C3"
  },
  "7316UP-759": {
    "ATM": "wild-type",
    "ATRX": "wild-type",
    "BRAF": "wild-type",
    "H3-3A": "wild-type",
    "Diagnosis": "Astrocytoma;Oligoastrocytoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Male",
    "HARMONY_Simple_Diagnosis": "Astrocytoma",
    "HARMONY_WHO_Grade": "3",
    "HARMONY_age": 33.02486037,
    "HARMONY_age_class_derived": "(26,40]",
    "Age class": "YA",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 2185,
    "Overall Survival Status": "Alive",
    "HARMONY_pfs": 2185,
    "HARMONY_pfs_status": "wild-type",
    "HARMONY_treat_status": "Post-treatment",
    "Tumor location": "Other/Multiple locations/NOS",
    "HARMONY_upenn": true,
    "IDH1": "mutated",
    "NF1": "wild-type",
    "TP53": "wild-type",
    "Protein Subtype": "C3"
  },
  "7316UP-904": {
    "Diagnosis": "Glioblastoma",
    "HARMONY_First_Diagnosis": "Yes",
    "Sex": "Male",
    "HARMONY_Simple_Diagnosis": "Glioblastoma",
    "HARMONY_WHO_Grade": "4",
    "HARMONY_age": 37.84360968,
    "HARMONY_age_class_derived": "(26,40]",
    "Age class": "YA",
    "HARMONY_dasc": "Alive",
    "HARMONY_os": 687,
    "Overall Survival Status": "Dead",
    "HARMONY_pfs": 281,
    "HARMONY_pfs_status": "mutated",
    "HARMONY_treat_status": "Post-treatment",
    "Tumor location": "Other/Multiple locations/NOS",
    "HARMONY_upenn": true,
    "Protein Subtype": "C2"
  }
}